import dayjs, { Dayjs } from "dayjs";
import { FilterValue } from "../../Filters/FilterValue";
import { SortType } from "../../SortType";
export interface UnpaidSamplesAnalyticsFilters {
  page_no: number;
  limit: number;
  sales_admin_id: FilterValue[] | null;
  archived: FilterValue[] | null;
  pending_since: FilterValue[] | null;
  order_id: FilterValue[] | null;
  start_date: Dayjs;
  end_date: Dayjs;
  sort_by: string;
  sort_type: SortType;
}

export interface UnpaidSamplesAnalyticsSelectedFilters {
  page_no: number;
  limit: number;
  sales_admin_id: FilterValue[] | null;
  archived: FilterValue[] | null;
  pending_since: FilterValue[] | null;
  order_id: FilterValue[] | null;
  start_date: string;
  end_date: string;
  sort_by: string;
  sort_type: SortType;
}

export interface UnpaidSamplesAnalyticsAPIFilters {
  page_no: number;
  limit: number;
  sales_admin_id: FilterValue[] | null;
  archived: FilterValue[] | null;
  pending_since: FilterValue[] | null;
  order_id: FilterValue[] | null;
  start_date: string;
  end_date: string;
  sort_by: string;
  sort_type: string;
}

export function parseQueryParamsForUnpaidSamplesAnalyticsFilters(
  params: UnpaidSamplesAnalyticsFilters | null,
  query_params: URLSearchParams
): UnpaidSamplesAnalyticsFilters {
  const currentDate = dayjs().startOf("day");
  const previousMonthDate = currentDate.startOf("month");

  return {
    page_no: params?.page_no ?? 1,
    limit: params?.limit ?? 10,
    sales_admin_id: params?.sales_admin_id ?? [],
    order_id: params?.order_id ?? [],
    archived: params?.archived ?? [{ id: "1", value: "Active" }],
    pending_since: params?.pending_since ?? null,
    start_date: query_params.get("start_date")
      ? dayjs(query_params.get("start_date"), "YYYY-MM-DD")
      : previousMonthDate,
    end_date: query_params.get("end_date")
      ? dayjs(query_params.get("end_date"), "YYYY-MM-DD")
      : currentDate,
    sort_by: params?.sort_by ?? "o.created_date",
    sort_type: params?.sort_type ?? SortType.DESC,
  };
}
